import { BaseApi } from './base.api'

export class BlogAdminApi extends BaseApi {
	constructor() {
		super('api/admin/blog')
	}

	async getPosts({ page = 0, pageSize = 20, status, locale, cluster, intentId, q } = {}) {
		const searchParams = new URLSearchParams({
			page: String(page),
			pageSize: String(pageSize),
		})
		if (status) searchParams.set('status', status)
		if (locale) searchParams.set('locale', locale)
		if (cluster) searchParams.set('cluster', cluster)
		if (intentId) searchParams.set('intentId', intentId)
		if (q) searchParams.set('q', q)
		return this.get(`/posts?${searchParams.toString()}`)
	}

	async getPost(pk) {
		return this.get(`/posts/${pk}`)
	}

	async createPost(data) {
		return this.post('/posts', data)
	}

	async updatePost(pk, data) {
		return this.put(`/posts/${pk}`, data)
	}

	async deletePost(pk) {
		return this.delete(`/posts/${pk}`)
	}

	async publishPost(pk) {
		return this.post(`/posts/${pk}/publish`, {})
	}

	async archivePost(pk) {
		return this.post(`/posts/${pk}/archive`, {})
	}
}
